define('SC.ThreadsThemeExtension.Home', [
  'underscore',
  'SC.ThreadsThemeExtension.Common.Configuration',
  'SC.ThreadsThemeExtension.Common.LayoutHelper'
], function ThemeExtensionHome(_, Configuration, LayoutHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      var carousel = Configuration.get('home.themeCarouselImages', []);
      var infoblock = Configuration.get('home.infoblock', []);
      var infoblockTile = false;
      var showCarousel = false;
      var carouselObj;
      var isReady = false;

      LayoutHelper.addToViewContextDefinition(
        'Home.View',
        'extraHomeViewContext',
        'object',
        function (context) {
          carouselObj = context.carousel;
          isReady =
            _.has(context, 'isReady') && !_.isUndefined(context.isReady)
              ? context.isReady
              : true;

          if (!_.isEmpty(carouselObj)) {
            _.each(carouselObj, function (carousel) {
              if (!_.isEmpty(carousel.image)) {
                _.extend(carousel, {
                  isAbsoluteUrl: carousel.image.indexOf('core/media') !== -1
                });
              }
            });
          } else {
            carouselObj = carousel;
          }

          return {
            isReady: isReady,
            showCarousel: carouselObj && !!carouselObj.length,
            carousel: carouselObj,
            infoblock: infoblock,
            freeTextText: _(
              Configuration.get('home.freeTextText', '')
            ).translate(),
            freeTextTitle: _(
              Configuration.get('home.freeTextTitle')
            ).translate(),
            freeTextSubtitle: _(
              Configuration.get('home.freeTextSubtitle')
            ).translate(),
            freeTextBtnText: _(
              Configuration.get('home.freeTextBtnText')
            ).translate(),
            freeTextBtnHref: _(
              Configuration.get('home.freeTextBtnHref')
            ).translate()
          };
        }
      );
    }
  };
});
